import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Colors from '../common/NekoTheme';

const LinkContainer = Styled.div`
  display: flex;
  align-items: center;
`;

const StyledNekoQuickLinks = props => {

  const [isActiveTabIndex, setIsActiveTabIndex] = React.useState(undefined);

  const children = React.Children.map(props.children, (child, i) => {
    return React.cloneElement(child, {
      isActive: typeof isActiveTabIndex === 'undefined' ? child.props.isActive : i === isActiveTabIndex,
      onClick: () => {
        setIsActiveTabIndex(i);
        if (child.props.onClick) {
          child.props.onClick();
        }
      }
    });
  });

  return (
    <LinkContainer>{children}</LinkContainer>
  );
};

const Link = Styled.p`
  color: ${Colors.blue};
  cursor: pointer;
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;

  &.is-active {
    cursor: default;
    color: ${Colors.black};
    font-weight: bold;
  }

  &::after {
    content: "|";
    color: ${Colors.darkGray};
    padding: 0 4px;
  }

  &:last-child::after {
    content: none;
  }

  span {
    color: ${Colors.darkGray};
    font-weight: normal;
    margin-left: 4px;
  }
`;

const StyledNekoLink = props => {

  const { title, value = 0, onClick, isActive } = props;

  const onClickHandle = () => {
    onClick();
  }

  return (
    <Link onClick={onClickHandle} className={`${isActive ? 'is-active' : ''}`}>
      { title }<span>({value})</span>
    </Link>
  )
}

const NekoQuickLinks = (props) => {
  return (<StyledNekoQuickLinks {...props} />);
}

NekoQuickLinks.propTypes = {
};

NekoQuickLinks.defaultProps = {
};

const NekoLink = (props) => {
  return (<StyledNekoLink {...props} />);
}

NekoLink.propTypes = {
  title: PropTypes.string,
  value: PropTypes.number,
  onClick: PropTypes.func,
  isActive: PropTypes.bool
};

NekoLink.defaultProps = {
  title: undefined,
  value: 0,
  onClick: undefined,
  isActive: false
};

export { NekoQuickLinks, NekoLink };
